import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';

const Academics = () => {
  const [booklists, setBooklists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBooklists();
  }, []);

  const fetchBooklists = async () => {
    try {
      // Try the main API first
      let response = await fetch('https://admin.pakschoolandcollege.com/api/booklist.php');
      
      if (!response.ok) {
        console.log('Main API failed, trying test endpoint...');
        // Try the test endpoint
        response = await fetch('https://admin.pakschoolandcollege.com/test-booklist-api.php');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      }
      
      const result = await response.json();
      
      if (result.success) {
        setBooklists(result.data);
      } else {
        console.error('Failed to fetch booklists:', result.error);
        // Fallback to static data if API fails
        setBooklists(getStaticBooklists());
      }
    } catch (error) {
      console.error('Error fetching booklists:', error);
      // Fallback to static data if API fails
      setBooklists(getStaticBooklists());
    } finally {
      setLoading(false);
    }
  };

  const getStaticBooklists = () => {
    return [
      { grade: 'Nursery', badge: 'Early Years', badgeColor: 'bg-pink-600', file: 'NURSERY-BOOKLIST-2025-26.pdf' },
      { grade: 'KG', badge: 'Early Years', badgeColor: 'bg-pink-600', file: 'KG-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 1', badge: 'Primary', badgeColor: 'bg-blue-600', file: 'GRADE-1-BOOKLIST-202526.pdf' },
      { grade: 'Grade 2', badge: 'Primary', badgeColor: 'bg-blue-600', file: 'GRADE-2-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 3', badge: 'Primary', badgeColor: 'bg-blue-600', file: 'GRADE-3-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 4', badge: 'Primary', badgeColor: 'bg-blue-600', file: 'GRADE-4-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 5', badge: 'Primary', badgeColor: 'bg-blue-600', file: 'GRADE-5-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 6', badge: 'Middle', badgeColor: 'bg-green-600', file: 'GRADE-6-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 7', badge: 'Middle', badgeColor: 'bg-green-600', file: 'GRADE-7-BOOKLIST-2025-26.pdf' },
      { grade: 'Grade 8', badge: 'Middle', badgeColor: 'bg-green-600', file: 'GRADE-8-BOOKLIST-2025-26.pdf' }
    ];
  };
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-900 via-blue-900 to-indigo-900 text-white py-20 px-4 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full"></div>
          <div className="absolute top-32 right-20 w-16 h-16 border-2 border-white rounded-full"></div>
          <div className="absolute bottom-20 left-1/4 w-12 h-12 border-2 border-white rounded-full"></div>
          <div className="absolute bottom-32 right-1/3 w-24 h-24 border-2 border-white rounded-full"></div>
        </div>
        
        <div className="relative max-w-6xl mx-auto text-center">
          <div className="mb-8">
            <div className="inline-block bg-white bg-opacity-25 backdrop-blur-sm px-6 py-3 rounded-full mb-6 border border-white border-opacity-30">
              <span className="text-sm font-medium text-white">📚 Academic Excellence</span>
            </div>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-8 leading-tight text-white">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-pink-400">Academics</span>
          </h1>
          <p className="text-xl md:text-2xl text-white max-w-4xl mx-auto leading-relaxed font-light">
            Excellence in education through comprehensive curriculum and modern teaching methods
          </p>
          <div className="mt-12 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 rounded-full"></div>
        </div>
      </div>
      </section>

      {/* Academic Overview Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-green-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Our Excellence
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              Our Academic Excellence
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                At PAK School & College System, we provide a comprehensive educational experience that 
                combines traditional values with modern teaching methodologies. Our curriculum is designed 
                to foster critical thinking, creativity, and character development.
              </p>
                </div>
                
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {[
                  { icon: '📚', title: 'Comprehensive Curriculum', desc: 'Well-structured programs from Play Group to Grade 8', color: 'from-blue-500 to-blue-600' },
                  { icon: '🎯', title: 'Modern Teaching Methods', desc: 'Interactive learning with technology integration', color: 'from-green-500 to-green-600' },
                  { icon: '📊', title: 'Regular Assessments', desc: 'Continuous evaluation and progress tracking', color: 'from-purple-500 to-purple-600' },
                  { icon: '🌟', title: 'Character Building', desc: 'Focus on moral values and Islamic education', color: 'from-orange-500 to-orange-600' }
                ].map((feature, index) => (
                  <div key={index} className="bg-gradient-to-br from-gray-50 to-blue-50 p-6 rounded-2xl hover:shadow-lg transition-all duration-300">
                    <div className={`w-12 h-12 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center text-xl mb-4`}>
                      {feature.icon}
                  </div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.desc}</p>
                </div>
                ))}
                  </div>
                </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-green-100 to-blue-100 p-8 rounded-3xl">
                <img 
                  src="/assets/mix-images/WhatsApp-Image-2024-01-27-at-9.47.43-PM-1.jpeg" 
                  alt="Academic Environment" 
                  className="w-full h-64 md:h-80 object-cover rounded-2xl shadow-lg"
                />
                  </div>
            </div>
          </div>
        </div>
      </section>

      {/* Academic Programs Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-green-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Our Programs
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Academic Programs</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive education for every stage of development
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: '👶',
                title: 'Early Years',
                subtitle: 'Play Group, Nursery, KG',
                features: ['Montessori-based learning', 'Nazra and Fehm-ul-Quran', 'Creative activities', 'Social development'],
                color: 'from-pink-500 to-pink-600'
              },
              {
                icon: '🎒',
                title: 'Primary Education',
                subtitle: 'Grade 1 - Grade 5',
                features: ['Core subjects foundation', 'Islamic studies', 'Computer literacy', 'Extracurricular activities'],
                color: 'from-blue-500 to-blue-600'
              },
              {
                icon: '🎓',
                title: 'Middle School',
                subtitle: 'Grade 6 - Grade 8',
                features: ['Advanced curriculum', 'Science and mathematics', 'Language development', 'Leadership skills'],
                color: 'from-green-500 to-green-600'
              }
            ].map((program, index) => (
              <div key={index} className="group">
                <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className={`w-16 h-16 bg-gradient-to-br ${program.color} rounded-2xl flex items-center justify-center text-2xl mb-6 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                    {program.icon}
            </div>
                  <div className="text-center mb-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{program.title}</h3>
                    <p className="text-sm text-gray-600 font-medium">{program.subtitle}</p>
            </div>
                  <ul className="space-y-3">
                    {program.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center space-x-3 text-sm text-gray-600">
                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                        <span>{feature}</span>
                      </li>
                    ))}
              </ul>
            </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booklist Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-purple-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Resources
          </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Booklist & Resources</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Download the required books and materials for each grade
            </p>
            </div>
            
          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
              <p className="text-gray-600 mt-4">Loading booklists...</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {booklists.map((booklist, index) => (
              <div key={index} className="group">
                <div className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-gray-100">
                  <div className="flex items-center justify-between mb-3">
                    <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center text-white text-sm font-bold">
                      📚
              </div>
                    <span className={`${booklist.badgeColor} text-white px-2 py-1 rounded-full text-xs font-medium`}>
                      {booklist.badge}
                    </span>
            </div>
            
                  <h3 className="text-sm font-bold text-gray-800 mb-2">{booklist.grade}</h3>
                  <p className="text-xs text-gray-600 mb-3">Complete booklist</p>
                  
                  <a 
                    href={`https://admin.pakschoolandcollege.com/assets/booklist/${booklist.file}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white py-2 px-3 rounded-lg text-xs font-medium hover:from-blue-600 hover:to-purple-600 transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-1"
                  >
                    <span>📖</span>
                    <span>View PDF</span>
                  </a>
                </div>
              </div>
              ))}
            </div>
          )}
            </div>
      </section>

      {/* Facilities Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-orange-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Our Facilities
              </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Academic Facilities</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Modern facilities to support quality education
            </p>
            </div>
            
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: '💻', title: 'Computer Lab', desc: 'Well-equipped computer laboratory with modern technology for digital learning', color: 'from-blue-500 to-blue-600' },
              { icon: '📚', title: 'Library', desc: 'Well-stocked library with extensive collection of books and resources', color: 'from-green-500 to-green-600' },
              { icon: '🔬', title: 'Science Lab', desc: 'Modern science laboratory for hands-on learning and experiments', color: 'from-purple-500 to-purple-600' },
              { icon: '🏃', title: 'Playground', desc: 'Vast playgrounds for sports and physical activities', color: 'from-orange-500 to-orange-600' }
            ].map((facility, index) => (
              <div key={index} className="group">
                <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                  <div className={`w-16 h-16 bg-gradient-to-br ${facility.color} rounded-2xl flex items-center justify-center text-2xl mb-4 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                    {facility.icon}
              </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 text-center">{facility.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed text-center">{facility.desc}</p>
              </div>
            </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-indigo-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-4">
              Get In Touch
          </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Contact Information</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              For more information about our academic programs and admission process
            </p>
            </div>
            
          <div className="bg-gradient-to-br from-gray-50 to-blue-50 p-8 rounded-2xl shadow-lg">
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '📞', title: 'Call Us', info: '0343-0001144/55/66/77', color: 'from-blue-500 to-blue-600' },
                { icon: '📧', title: 'Email Us', info: 'info@pakschoolandcollege.com', color: 'from-green-500 to-green-600' },
                { icon: '📍', title: 'Visit Us', info: 'Nehr Chowk, Swabi Road Mardan', color: 'from-purple-500 to-purple-600' }
              ].map((contact, index) => (
                <div key={index} className="text-center p-6 bg-white rounded-xl hover:shadow-md transition-all duration-300">
                  <div className={`w-16 h-16 bg-gradient-to-br ${contact.color} rounded-2xl flex items-center justify-center text-2xl mx-auto mb-4`}>
                    {contact.icon}
            </div>
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">{contact.title}</h4>
                  <p className="text-sm text-gray-600">{contact.info}</p>
            </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Academics;
